import { useGetRequest } from "@ch/api/useGetRequest";
import { type Medication, MedicationControllerService } from "@ch/generated";
import { useState } from "react";

const useMedicationsGet = () => {
  const [medications, setMedications] = useState<Medication[]>([]);

  const { loading } = useGetRequest({
    service: MedicationControllerService.medicationControllerFind.bind(
      MedicationControllerService,
    ),
    tag: "medicationControllerFind",
    payload: {},
    onSuccess: (data: Medication[]) => {
      void setMedications(data);
    },
  });

  return {
    loadingMedications: loading,
    medications,
  };
};

export default useMedicationsGet;
